import * as Sentry from '@sentry/browser';
import { getElementConstantHeight } from '@utils/elements';
import { isPayingUser } from '@utils/user';
import { halfPageManagerPrepareRepeaters as prepareRepeaters } from './halfPageManagerPrepareRepeaters';
import { halfPageManagerInsertRepeaters as insertRepeaters } from './halfPageManagerInsertRepeaters';
import { halfPageManagerUpdateRepeaterHeights as updateRepeaterHeights } from './halfPageManagerUpdateRepeaterHeights';
import { halfPageManagerState as state } from './halfPageManagerState';

export const halfPageManagerRecalculate = () => {
  // Pokud je platící uživatel, nevykonávat
  if (isPayingUser()) return;

  const oldContent: HTMLElement | undefined = state.getContentElement();
  if (!oldContent) throw new Error('Old content element not found');

  const oldContentHeight: number = oldContent.offsetHeight;

  // Přepočítat výšku obsahu levého sloupce
  getElementConstantHeight({
    el: oldContent,
  })
    .then((constantHeight: number) => {
      // Vložit repeatery
      state.setContentHeight(constantHeight);
      prepareRepeaters(oldContentHeight);
      insertRepeaters();
      updateRepeaterHeights();
    })
    .catch((err) => {
      Sentry.captureException(err);
      if (err instanceof Error) {
        throw new Error(err.message);
      } else {
        throw new Error('Unexpected error in recalculating halfpage adverts.');
      }
    });
};
